export default __webpack_public_path__ + "static/media/img-ln3-video.6135b06c.png";